"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOriginalPillowBundleSku = exports.getSkuByBundleKey = exports.calculateAddedItemsQuantity = exports.isBeddingItemsGreaterThan200 = exports.calculateCartInfo = exports.canBeABundle = exports.isPillowSku = exports.isPillowBundle = exports.getCartIdInParams = exports.buildErrorMessage = exports.api = void 0;
const pattern_library_utils_cookies_1 = require("@saatva-bits/pattern-library.utils.cookies");
const globals_1 = require("../globals");
const api = async (uri, { query, variables }) => {
    try {
        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Compress the response, otherwise the query will take a long time.
                'Accept-Encoding': `gzip, deflate, br`,
            },
            body: JSON.stringify({
                query,
                variables: variables || {}
            })
        };
        const response = await fetch(uri, fetchOptions);
        const { data } = await response.json();
        return data;
    }
    catch (error) {
        throw new Error(error);
    }
};
exports.api = api;
const buildErrorMessage = (action, message, error, throwError = true) => {
    const endMessage = `with error message: ${error.message}`;
    const errorMessage = `${action} ${message} ${endMessage}`;
    if (throwError) {
        throw new Error(errorMessage);
    }
    else {
        console.log(errorMessage); // eslint-disable-line no-console
    }
};
exports.buildErrorMessage = buildErrorMessage;
// Gets an existing cartId from a query param or from cookies
const getCartIdInParams = () => {
    if (typeof window === 'undefined') {
        return null;
    }
    const searchParams = new URLSearchParams(window.location.search);
    const cartCookie = pattern_library_utils_cookies_1.Cookies.get('cartId');
    if (searchParams.has('cartId')) {
        return searchParams.get('cartId');
    }
    if (cartCookie) {
        return cartCookie;
    }
    return null;
};
exports.getCartIdInParams = getCartIdInParams;
const isPillowBundle = (sku) => Object.values(globals_1.pillowBundleSkus).includes(sku);
exports.isPillowBundle = isPillowBundle;
const isPillowSku = (sku) => {
    return globals_1.pillows.includes(sku) || globals_1.queenPillowSkus.includes(sku) || globals_1.kingPillowSkus.includes(sku);
};
exports.isPillowSku = isPillowSku;
const canBeABundle = (product) => {
    return !(0, exports.isPillowBundle)(product.sku) && (0, exports.isPillowSku)(product.productCode);
};
exports.canBeABundle = canBeABundle;
const calculateCartInfo = (cartData) => {
    const cartInfo = {
        quantity: cartData.totalItems,
        subtotal: cartData.subtotal
    };
    pattern_library_utils_cookies_1.Cookies.set('cartInfo', cartInfo);
};
exports.calculateCartInfo = calculateCartInfo;
// Specific logic to apply the 10OFFBEDDING coupon only when the sum of bedding product prices is greater or equal to 200.
const isBeddingItemsGreaterThan200 = async (cart) => {
    const beddingSubtotal = cart.items.reduce((acc, cartItem) => {
        let priceToAdd = 0;
        if (cartItem.category === 'Bedding') {
            priceToAdd = cartItem.price * cartItem.quantity;
        }
        return acc + priceToAdd;
    }, 0);
    return beddingSubtotal >= 200;
};
exports.isBeddingItemsGreaterThan200 = isBeddingItemsGreaterThan200;
const calculateAddedItemsQuantity = (items) => {
    if (!Array.isArray(items) || items.length === 0) {
        return 0;
    }
    const totalQuantity = items.reduce((acc, currentItem) => {
        if (currentItem.quantity && typeof currentItem.quantity === 'number') {
            return acc + currentItem.quantity;
        }
        return acc;
    }, 0);
    return totalQuantity;
};
exports.calculateAddedItemsQuantity = calculateAddedItemsQuantity;
const getSkuByBundleKey = (sku) => {
    return globals_1.pillowBundleSkus[sku] || sku;
};
exports.getSkuByBundleKey = getSkuByBundleKey;
const getOriginalPillowBundleSku = (sku) => {
    const values = Object.values(globals_1.pillowBundleSkus);
    const keys = Object.keys(globals_1.pillowBundleSkus);
    const index = values.indexOf(sku);
    return keys[index];
};
exports.getOriginalPillowBundleSku = getOriginalPillowBundleSku;
//# sourceMappingURL=utils.js.map